export default __webpack_public_path__ + "static/media/4.b2dc9243.png";